var parent = require('../../stable/instance/bind');

module.exports = parent;



//////////////////
// WEBPACK FOOTER
// ./node_modules/core-js-pure/actual/instance/bind.js
// module id = 484
// module chunks = 0 1